/**
 * SearchAction type
 * DOC: https://schema.org/SearchAction
 */

import entryPoint from './entryPoint';
export default ({
  target,
  queryInput
}) => ({
  '@type': 'SearchAction',
  'target': entryPoint(target),
  'query-input': queryInput
});